import StarIcon from "@mui/icons-material/Star";
import { Box, SxProps, Theme } from "@mui/material";
import { Text } from "@src/lib/ui-react";
import { STARRED_PROFESSIONAL_COLOR } from "@src/appV2/Professionals/StarredProfessionals/constants";
import { isDefined } from "@clipboard-health/util-ts";
import { mergeSxProps } from "../../../../../appV2/lib";

interface StarProfessionalTagProps {
  backgroundColor?: string;
  showText?: boolean;
  sx?: SxProps<Theme>;
}

export function StarProfessionalTag(props: StarProfessionalTagProps) {
  const { backgroundColor, showText = true, sx } = props;
  return (
    <Box
      sx={mergeSxProps(
        (theme: Theme) => ({
          borderRadius: 0.5,
          paddingY: 0,
          paddingX: 0.75,
          width: "fit-content",
          display: "flex",
          alignItems: "center",
          backgroundColor: isDefined(backgroundColor)
            ? backgroundColor
            : STARRED_PROFESSIONAL_COLOR,
          color: theme.palette.common.white,
        }),
        sx
      )}
    >
      <StarIcon sx={{ fontSize: (theme) => theme.typography.pxToRem(12) }} />
      {showText && (
        <Text variant="caption" color="inherit" marginLeft={0.5}>
          Starred
        </Text>
      )}
    </Box>
  );
}
